import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import { RekapTransaksiFilter, RekapTransaksiResponse } from "@/types/transaksi_bank_darah";

function paramsFilter(f: RekapTransaksiFilter) {
  return {
    tgl_start: f.tgl_start || undefined,
    tgl_end: f.tgl_end || undefined,
    jenis_rawat: f.jenis_rawat && f.jenis_rawat.length ? f.jenis_rawat.join(",") : undefined,
    unit: f.unit || undefined,
    cara_bayar: f.cara_bayar || undefined,
    pelayanan: f.pelayanan || undefined,
    term: f.term || undefined
  };
}

async function list(f: RekapTransaksiFilter): Promise<RekapTransaksiResponse> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-transaksi", { params: paramsFilter(f) })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function downloadExcel(f: RekapTransaksiFilter): Promise<void> {
  const res = await http
    .getDataParam("/laporan/bank-darah/rekap-transaksi/excel", {
      params: paramsFilter(f),
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = `rekap-transaksi-bank-darah_${f.tgl_start}_${f.tgl_end}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { list, downloadExcel };
